import type { DriveStep } from 'driver.js';

export const doctorSettingsSteps: DriveStep[] = [
  {
    element: '[data-tour="doctor-settings-profile"]',
    popover: {
      title: 'Your Profile',
      description: 'Name, title, specialty, and license. This info appears on your intake form.',
      side: 'right',
      align: 'center',
    },
  },
  {
    element: '[data-tour="doctor-settings-vanity"]',
    popover: {
      title: 'Custom Intake URL',
      description:
        'Customize your intake URL (e.g. expertmd.io/dr-your-name). Check availability before saving.',
      side: 'right',
      align: 'center',
    },
  },
  {
    element: '[data-tour="doctor-settings-encryption"]',
    popover: {
      title: 'Encryption Setup',
      description: 'Create a passphrase for end-to-end encryption. Cannot be recovered if lost.',
      side: 'right',
      align: 'center',
    },
  },
];
